module.exports = __webpack_public_path__ + "static/media/p5-4.1be564df.png";